import type { ReactNode } from "react";
import { FileText, GitBranch } from "lucide-react";
import { StepInfoRow } from "../StepInfoRow";
import { getBool } from "./helpers";
import type { SummaryTranslator } from "./types";

export function getConditionalSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const conditions = Array.isArray(config.conditions)
    ? (config.conditions as { expression: string; targetStep: string }[])
    : [];

  if (conditions.length > 0) {
    items.push(
      <StepInfoRow
        key="branches"
        icon={<GitBranch className="size-3.5" />}
        label={t("summaries.conditional.label_branches")}
        value={
          <span className="rounded bg-violet-100 px-1.5 py-0.5 text-[10px] font-medium text-violet-700 dark:bg-violet-900/30 dark:text-violet-300">
            {t("summaries.conditional.conditions_count", { count: conditions.length })}
          </span>
        }
      />
    );

    conditions.slice(0, 2).forEach((c, i) => {
      const truncExpr = c.expression.length > 45 ? c.expression.slice(0, 45) + "..." : c.expression;
      items.push(
        <StepInfoRow key={`if-${i}`} icon={<FileText className="size-3.5" />} label={t("summaries.conditional.label_if")} value={truncExpr} mono />
      );
    });

    if (conditions.length > 2) {
      items.push(
        <div key="more" className="pl-6 text-[10px] text-gray-400 dark:text-gray-500">
          {t("summaries.conditional.more_branches", { count: conditions.length - 2 })}
        </div>
      );
    }
  }

  if (getBool(config.defaultBranch)) {
    items.push(
      <StepInfoRow
        key="default"
        icon={<GitBranch className="size-3.5" />}
        label={t("summaries.conditional.label_default")}
        value={
          <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-400">
            {t("summaries.conditional.default_yes")}
          </span>
        }
      />
    );
  }

  return items;
}
